import React from "react";
import SocialIcon from "../SocialIcon/SocialIcon";
import { ContactWrapper, Email } from "./ContactElements";
function Contact() {
  return (
    <ContactWrapper id="contact">
      <div className="Container">
        <div className="SectionTitle">Get In Touch</div>
        <div className="BigCard">

          <Email>
            <span>📧 Email<br/>johnyobah8@gmail.com</span>
            <a
              className="btn PrimaryBtn"
              href="mailto:johnyobah8@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
           Send Email
            </a>
          </Email>

          <Email>
            <span>📞 Phone Numbers<br/>+260 779 270 234<br/>+260 964 572 054</span>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <a
                className="btn PrimaryBtn"
                href="tel:+260964572054"
                target="_blank"
                rel="noopener noreferrer"
              >
                Call Now
              </a>
              <a
                className="btn PrimaryBtn"
                href="https://wa.me/260964572054"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp
              </a>
            </div>
          </Email>
        </div>
        <SocialIcon />
      </div>
    </ContactWrapper>
  );
}

export default Contact;
